import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const EntitieSetupApi = createApi({
  reducerPath: "Entities",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND2_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getAllWorkshops: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 10;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
        const search = val.search ? `&search=${val.search}` : "";
        if (!limit && !page) {
          return "/v1/workshops";
        }
        return `/v1/workshops?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}`;
      },
    }),
    getWorkshopsList: builder.query({
      query: () => "/v1/workshops",
    }),
    deleteWorkshop: builder.mutation({
      query: (id) => ({
        url: `/v1/workshops/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllWorkshopsQuery,
  useGetWorkshopsListQuery,
  useDeleteWorkshopMutation,
} = EntitieSetupApi;
